export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-voronoi/src/constant.js
// module id = iD9I
// module chunks = 0